// triggered when number of notifications (related to data export) drops
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '@bettercomp/ui-components';
import { selectExportNotifications } from 'redux/notifications/selectors';

import { showNotification } from '../common/function';
import { PATH } from '../common/constants';

export function useExportNotificationsDeleteEvent() {
  const router = useRouter();
  const notifications = useSelector(selectExportNotifications);
  const [previousNotifications, setPreviousNotifications] = useState(notifications);

  const notificationBody = useMemo(() => (
    <div>
      Your file is available for download in the <br />
      <Button
        type="link"
        onClick={() => router.push(PATH.DOWNLOADS)}
        data-testid="downloadCenterButton"
      >
        Download Center
      </Button>
    </div>
  ), [router]);

  useEffect(() => {
    if (previousNotifications.length > notifications.length) {
      showNotification(notificationBody as any, 'Export Available', 'success');
    }

    setPreviousNotifications(notifications);
  }, [notifications, previousNotifications.length, notificationBody]);
}
